import { render, staticRenderFns } from "./message-text.vue?vue&type=template&id=6e1ce92d&scoped=true"
import script from "./message-text.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-text.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-text.vue?vue&type=style&index=0&id=6e1ce92d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1ce92d",
  null
  
)

export default component.exports